export const notes = [
  {
    noteTitle: 'Archive Search',
    note: 'Ability to search archived data',
  },
];
